import { ApolloLink, Observable } from "@apollo/client";
import type { FetchResult, Operation } from "@apollo/client";
import { print } from "graphql";
import type { Consumer } from "@rails/actioncable";

export class ActionCableLink extends ApolloLink {
  private cable: Consumer;

  constructor(options: { cable: Consumer }) {
    super();
    this.cable = options.cable;
  }

  request(operation: Operation): Observable<FetchResult> {
    return new Observable((observer) => {
      const channelId = Math.round(Date.now() + Math.random() * 100000).toString(16);

      const subscription = this.cable.subscriptions.create(
        { channel: "GraphqlChannel", channelId },
        {
          connected() {
            subscription.perform("execute", {
              query: print(operation.query),
              variables: operation.variables,
              operationName: operation.operationName,
            });
          },
          disconnected() {
            observer.error(new Error("ActionCable disconnected"));
          },
          received(payload: { result: FetchResult; more: boolean }) {
            if (payload.result) {
              observer.next(payload.result);
            }
            if (!payload.more) {
              observer.complete();
            }
          },
        }
      );

      return () => subscription.unsubscribe();
    });
  }
}
